import { requestOfferFromHistoryActions, setActiveOfferId } from './actions';
import { getOfferFromHistory } from './getOfferFromHistory';
import {
  selectActiveOfferId,
  selectOfferFromHistory,
  selectOffersHistoryData,
  selectOffersHistorySpoilerData,
} from '../../selectors/offersHistory';
import { TThunkAction } from '../../types/redux';
import { AuthRequiredError } from '../../errors/AuthRequiredError';
import { requestAuthentication } from '../authentication';
import { selectIsDesktop } from '../../selectors/page';

export const openOfferFromHistory =
  (params: IParams = {}): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    let state = getState();
    const offersHistoryData = selectOffersHistoryData(state);
    const offersHistorySpoilerData = selectOffersHistorySpoilerData(state);
    const activeOfferId = selectActiveOfferId(state);
    const isDesktop = selectIsDesktop(state);

    /** Выбираем id оффера, который нужно загрузить, в порядке приоритета */
    const cianId = params.cianId || offersHistoryData.data?.offers[0].id || offersHistorySpoilerData.data?.offers[0].id;

    /** Проверка на то, что вызывается открытие другого оффера */
    if (!cianId || activeOfferId === cianId) {
      return;
    }

    dispatch(setActiveOfferId(cianId));

    state = getState();
    const savedOfferFromHistory = selectOfferFromHistory(state);

    dispatch(requestOfferFromHistoryActions.reset());

    /** Повторно данные оффера загружаться не будут */
    if (savedOfferFromHistory) {
      return;
    }

    try {
      await dispatch(getOfferFromHistory({ cianId }));
    } catch (e) {
      if (e instanceof AuthRequiredError) {
        if (!isDesktop) {
          dispatch(setActiveOfferId(null));
          dispatch(
            requestAuthentication({
              onSuccess: () => dispatch(openOfferFromHistory(params)),
            }),
          );
        }
      }
    }
  };

interface IParams {
  cianId?: number | null;
}
